import { defineStore } from "pinia";
import config from "@/config";

const STORAGE_KEY_MINI_SIDEBAR = "customizer_mini_sidebar";

export const useCustomizerStore = defineStore("customizer", {
  state: () => ({
    Sidebar_drawer: config.Sidebar_drawer,
    Customizer_drawer: config.Customizer_drawer,
    mini_sidebar: config.mini_sidebar,
    setHorizontalLayout: config.setHorizontalLayout, // Horizontal layout
    actTheme: config.actTheme,
    boxed: config.boxed,
    setBorderCard: config.setBorderCard
  }),

  getters: {},
  actions: {
    initializeMiniSidebar() {
      try {
        const saved = localStorage.getItem(STORAGE_KEY_MINI_SIDEBAR);
        if (saved !== null) {
          this.mini_sidebar = JSON.parse(saved);
        }
      } catch (e) {
        console.warn("Failed to load mini_sidebar state:", e);
      }
    },
    SET_SIDEBAR_DRAWER() {
      this.Sidebar_drawer = !this.Sidebar_drawer;
    },
    SET_MINI_SIDEBAR(payload: boolean) {
      this.mini_sidebar = payload;
      localStorage.setItem(STORAGE_KEY_MINI_SIDEBAR, JSON.stringify(payload));
    },
    SET_CUSTOMIZER_DRAWER(payload: any) {
      this.Customizer_drawer = payload;
    },

    SET_LAYOUT(payload: any) {
      this.setHorizontalLayout = payload;
    },
    SET_THEME(payload: any) {
      this.actTheme = payload;
    },
    SET_CARD_BORDER(payload: any) {
      this.setBorderCard = payload;
    }
  }
});
